<template>
	<span
		>Oops! It looks like <i>{{ fileName }}</i> isn't a supported file type. Please choose an image, video, or PDF file to upload.</span
	>
</template>

<script>
	export default {
		props: {
			fileName: {
				type: String,
				required: true
			}
		}
	};
</script>
